/**
 * AnalyticsIcon/index.js
 * desc: analytics feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const AnalyticsIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="analytics icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.analytics.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 16h4V0H6v16zm-6 0h4V8H0v8zm12 0V5h4v11h-4z"/></svg>
    </IconButton>
);


export default AnalyticsIcon;
